module.exports = __webpack_public_path__ + "media/newstyle/images/icon-money-purple-ab53e61da57fb83a2ea8bc5c2d6c189a.svg";